var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('resource-text-editor',{attrs:{"is_flex":false,"payload":{ text_data: _vm.texts.abstract,
                                      designator: 'abstract',
                                      resource_type: 'Position',
                                      resource_id: _vm.payload.position_id,
                                      company_id: _vm.payload.company_id }}}),_c('resource-text-editor',{attrs:{"payload":{ text_data: _vm.texts.contact_email,
                                      designator: 'contact_email',
                                      resource_type: 'Position',
                                      resource_id: _vm.payload.position_id,
                                      company_id: _vm.payload.company_id }}}),_c('resource-text-editor',{attrs:{"payload":{ text_data: _vm.texts.position_company_id,
                                      designator: 'position_company_id',
                                      resource_type: 'Position',
                                      resource_id: _vm.payload.position_id,
                                      company_id: _vm.payload.company_id }}}),_c('resource-text-editor',{attrs:{"payload":{ text_data: _vm.texts.salary_expectations,
                                      designator: 'salary_expectations',
                                      resource_type: 'Position',
                                      resource_id: _vm.payload.position_id,
                                      company_id: _vm.payload.company_id }}}),_c('resource-text-editor',{attrs:{"is_flex":false,"payload":{ text_data: _vm.texts.work_entails,
                                      designator: 'work_entails',
                                      resource_type: 'Position',
                                      resource_id: _vm.payload.position_id,
                                      company_id: _vm.payload.company_id }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }